import script from "./help-page.vue?vue&type=script&setup=true&lang=js"
export * from "./help-page.vue?vue&type=script&setup=true&lang=js"

import "./help-page.vue?vue&type=style&index=0&id=bd4ef6f4&scoped=true&lang=scss"

import exportComponent from "D:\\Code\\wisecard\\smart-tms-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bd4ef6f4"]])

export default __exports__